import { render, staticRenderFns } from "./page-intro.vue?vue&type=template&id=dc1973ba&"
import script from "./page-intro.vue?vue&type=script&lang=js&"
export * from "./page-intro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports